import axios from 'axios';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import { toastWarning } from '../util/toastUtils';
import { exportFileTitle } from '../util/CommonUtils';
import { STORIES_FAILURE_MESSAGE_500_STATUS } from '../messages/messages';

export function downloadVisaReport({
  uid,
  accountId,
  token,
  productNo,
  weightType,
  divisor,
  selectedWeightName,
  targetLabel,
  targetExpression,
}) {
  const url = `${urls.ROOT_URL}/reports/exportcustomreport/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'POST',
      withCredentials: true,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'json',
      data: {
        reportName: 'VISA_RPT',
        productNo,
        weightType,
        divisor,
        selectedWeightName,
        targetLabel,
        targetExpression,
        fileName: exportFileTitle('VisaHaul'),
      },
    })
      .then(response => {
        if (response && response.status === 200) {
          window.open(response.data.data.url, '_self');
        }
      })
      .catch(error => {
        const response = error.response;
        if (response && response.status === 500) {
          toastWarning(STORIES_FAILURE_MESSAGE_500_STATUS);
        } else if (response && response.status === 400) {
          toastWarning(response.data.message);
        } else {
          toastWarning(STORIES_FAILURE_MESSAGE_500_STATUS);
        }
      });
  };
}
